import { useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { Container, Row, Col, Button, Form } from 'react-bootstrap'
import { updateDoc, doc, addDoc, collection } from 'firebase/firestore'
import { db } from '../../config/Firebase'
import { useUsers } from '../../contexts/UsersContext'

const QuoteDetails = () => {
  const location = useLocation()
  const params = useParams()
  const { loggedOnUser } = useUsers()
  const quote = location.state && location.state.quote
  const [showMsgForm, setShowMsgForm] = useState(false)
  const [moreInfo, setMoreInfo] = useState({})
  const [quoteSent, setQuoteSent] = useState({})
  const [showMsg1Form, setShowMsg1Form] = useState(false)

  const handleMoreInfo = async () => {
    setShowMsgForm(false)

    await addDoc(
      collection(db, 'commsSasi'),
      {
        from: loggedOnUser && loggedOnUser.email,
        quoteId: quote && quote.id,
        message: moreInfo.message,
        to: quote && quote.createdBy,
        status: 'new',
        createdAt: new Date().toLocaleString() + '',
        type: 'moreInfo',
      },
      { merge: true }
    )
  }

  const handleSendQuote = async () => {
    setShowMsgForm(false)

    await addDoc(
      collection(db, 'commsSasi'),
      {
        from: loggedOnUser && loggedOnUser.email,
        quoteId: quote && quote.id,
        message: quoteSent.message,
        to: quote && quote.createdBy,
        status: 'new',
        createdAt: new Date().toLocaleString() + '',
        type: 'quote',
      },
      { merge: true }
    )
  }

  const handleNotInterested = async () => {
    alert('Need brainstorming on this one')
  }

  return (
    <Container>
      <Row className='member-statistical'>
        <Col sm={12}>
          Quotation Details for quote no: {params && params.id}: <br />
          {quote && (
            <>
              {' '}
              {quote.created} : New jobs posted just now. The details are: We
              need {quote.serviceNeeded} of {quote.categoryNeeded} category at{' '}
              {quote.locationNeeded
                ? quote.locationNeeded
                : 'Location is not Specified by customer'}{' '}
              and special requirements by customer:{' '}
              {quote.details ? quote.details : 'None'}.
              <br /> service details:{' '}
              {quote.checks &&
                quote.checks.map((check, index) => (
                  <div key={index}>
                    {check.type}: {check.option}
                    <br />
                  </div>
                ))}
              {quote.radios &&
                quote.radios.map((radio, index) => (
                  <div key={index}>
                    {' '}
                    {radio.type}: {radio.option}
                    <br />
                  </div>
                ))}
            </>
          )}
          <Button
            onClick={() => {
              setShowMsgForm(false)
              setShowMsg1Form(true)
            }}
          >
            Quote
          </Button>
          <Button
            onClick={() => {
              setShowMsgForm(true)
              setShowMsg1Form(false)
            }}
          >
            More Info
          </Button>
          {/* <Button onClick={handleNotInterested}>Not interested</Button> */}
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          {showMsgForm && (
            <div>
              <h3>Send a message to customer</h3>
              <Form.Control
                as='textarea'
                rows={3}
                onChange={(e) =>
                  setMoreInfo({ ...moreInfo, message: e.target.value })
                }
              />{' '}
              <Button
                variant='danger'
                onClick={() => {
                  setShowMsgForm(false)
                  setMoreInfo({})
                }}
              >
                Cancel
              </Button>
              <Button onClick={handleMoreInfo}>Send</Button>
            </div>
          )}
          {showMsg1Form && (
            <div>
              <h3>Send a quote to customer</h3>
              <Form.Control
                as='textarea'
                rows={3}
                onChange={(e) =>
                  setQuoteSent({ ...quoteSent, message: e.target.value })
                }
              />{' '}
              <Button
                variant='danger'
                onClick={() => {
                  setShowMsg1Form(false)
                  setQuoteSent({})
                }}
              >
                Cancel
              </Button>
              <Button onClick={handleSendQuote}>Send</Button>
            </div>
          )}
        </Col>
      </Row>
    </Container>
  )
}

export default QuoteDetails
